:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._sectionControlsButton_1q6cp_7 {
  pointer-events: auto;
  cursor: pointer;
  display: inline-block;
  margin-right: 6px;
  border-radius: 18px;
  background-color: #fff;
  box-shadow: 0 2px 6px 0 rgba(22, 45, 61, 0.36);
  min-width: 36px;
  height: 36px;
  line-height: 36px;
  position: relative;
  color: #2d3034;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.15), 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 18px 0 rgba(0, 0, 0, 0.08); }
  ._sectionControlsButton_1q6cp_7 > ._symbol_1q6cp_21 {
    position: absolute;
    top: 50%;
    left: 18px;
    transform: translate(-50%, -50%); }
    ._sectionControlsButton_1q6cp_7 > ._symbol_1q6cp_21 * {
      fill: #2d3034; }
  ._sectionControlsButton_1q6cp_7:not(._withLabel_1q6cp_28):hover {
    background-color: #116dff; }
    ._sectionControlsButton_1q6cp_7:not(._withLabel_1q6cp_28):hover > ._symbol_1q6cp_21 * {
      fill: #fff; }
  ._sectionControlsButton_1q6cp_7._withLabel_1q6cp_28 {
    padding: 0 10px 0 36px; }
    ._sectionControlsButton_1q6cp_7._withLabel_1q6cp_28:hover {
      background-color: #116dff;
      color: #fff; }
      ._sectionControlsButton_1q6cp_7._withLabel_1q6cp_28:hover > ._symbol_1q6cp_21 * {
        fill: #fff; }
  ._sectionControlsButton_1q6cp_7._disabled_1q6cp_39 {
    background-color: #fff !important;
    cursor: default; }
    ._sectionControlsButton_1q6cp_7._disabled_1q6cp_39 > ._symbol_1q6cp_21 * {
      fill: #bcbcbc !important; }
